/**
 * Every day within a year the country's distance to Denmark changes
 * (19/10/2026) — the days a Danish schedule lands an hour earlier or later
 * in the country (shared `nextClockChange`). A change happens INSIDE a run
 * day — its first hours, or the evening before, and an end can reach into
 * the next morning — so the days next to it can be part old, part new
 * distance: `timingDays` adds them, and covers every way the drops can fall
 * against the window all year.
 * For Media Devoted | Created By Ciro Autiero
 */
import { addDaysIso, nextClockChange } from '@trafficpulse/shared';

/** The clock-change run dates after `fromRunDate`, up to `horizonDays` ahead, in date order. */
export function clockChangeDays(tz: string | null, fromRunDate: string, horizonDays = 365): string[] {
  const last = addDaysIso(fromRunDate, horizonDays);
  const out: string[] = [];
  for (let c = nextClockChange(tz, fromRunDate); c && c.runDate <= last; c = nextClockChange(tz, c.runDate)) out.push(c.runDate);
  return out;
}

/** Today first, then — when the distance ever changes — tomorrow and, around each change, the day before, the
 *  day itself and the day after, in date order: every distinct timing of a Danish schedule within the horizon. */
export function timingDays(tz: string | null, today: string, horizonDays = 365): string[] {
  const changes = clockChangeDays(tz, today, horizonDays);
  if (changes.length === 0) return [today];
  const around = (d: string) => [addDaysIso(d, -1), d, addDaysIso(d, 1)];
  return [...new Set([today, addDaysIso(today, 1), ...changes.flatMap(around)])].sort();
}
